{
    "FullName": "Nome completo:",
    "FullNamePlaceholder": "[Nome Completo Não Especificado]",
    "UsernameHint": "O nome de usuário não precisa ser um endereço de e-mail, mas deve ser exclusivamente identificável e diferencia maiúsculas de minúsculas",
    "UsernameEditHint": "Ao editar um nome de usuário, a senha deve ser reinserida",
    "Email": "E-mail:",
    "EmailPlaceholder": "exemplo@akixi.com",
    "EmailHint": "Para onde as mensagens de e-mail geradas automaticamente pelo Akixi são enviadas. (Novos usuários\/e-mails de boas-vindas, redefinições de senha e relatórios programados)",
    "Defaultlanguage": "Idioma do e-mail:",
    "DefaultlanguageHint": "Define o idioma padrão para a plataforma e emails correspondentes",
    "Passwordchange": "Alteração de senha necessária:",
    "Welcomeemail": "Enviar e-mail de boas-vindas:",
    "WelcomeemailHelp": "Esta opção está disponível quando um endereço de e-mail e uma senha válidos foram inseridos e a configuração de Alteração de Senha Necessária está habilitada",
    "NameValidation": "O nome completo não deve ter mais de 100 caracteres",
    "UsernameRequiredValidation": "O nome de usuário não pode ficar em branco",
    "EmailPatternValidation": "Por favor insira um endereço de e-mail válido",
    "PasswordLengthValidation": "A senha é muito curta",
    "PasswordRequiredValidation": "A senha não pode ficar em branco",
    "PasswordStrengthValidation": "A senha não é forte o suficiente (certifique-se de incluir letras maiúsculas e minúsculas, bem como números)",
    "UserDetailsLanguage_Username": "Nome do usuário:",
    "UserDetailsLanguage_Password": "Senha:",
    "UserDetailsLanguage_PasswordPlaceholder": "••••••••",
    "NAME": "UserDetailsLanguage",
    "UsernameIDOnTelSysHint": "O nome de utilizador não pode ser editado para este tipo de subscrição. Tem de corresponder ao nome de utilizador na plataforma de telefonia.",
    "EmailRequiredValidation": "O endereço de correio eletrónico não pode estar em branco",
    "UserDetailsLanguage_MFA_Label": "Ativar a MFA:",
    "UserDetailsLanguage_MFAHelp": "A ativação da autenticação multifactor (MFA) significa que o utilizador terá de introduzir um código da sua aplicação de autenticação ao iniciar sessão.",
    "Timezone_Title": "Fuso horário:",
    "UserDetailsLanguage_CXIntegration": "Integração CX:",
    "UsernameMustBeSetFromDeviceValidation": "Para obter o nome de usuário para este tipo de usuário, certifique-se de que o dispositivo esteja definido na guia de permissões"
}